import React from "react";
import { Dropdown, DatePicker } from "@my-scoot/component-library-legacy";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import classnames from "classnames";
import { format } from "date-fns";

import StatsCard from "common/Components/StatsCard";
import { convertStringToDateObject } from "features/Common/modules/DateTime/utils/DateTime.utils";
import { YEAR_MONTH_DAY_FORMAT } from "features/Common/modules/DateTime/DateTime.constants";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { formatRevenue } from "features/Common/utils/common.utils";

import {
  date_range_select_options,
  STAT_CARDS,
} from "../../discounts.constants";
import { useDiscountCodeStats } from "./utils/hooks/useDiscountCodeStats";

const StatsLoadingState = ({ color }) => (
  <CircularProgress size={18} color={color} />
);

export const DiscountCodeStats = () => {
  const isDesktop = useMediaQuery("(min-width: 767px)");
  const {
    discountStatsData,
    dataRange,
    selectedRange,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    onRangeChange,
  } = useDiscountCodeStats();

  return (
    <Box className="">
      <div
        className={classnames(
          "tw-mb-[18px] tw-flex",
          selectedRange === date_range_select_options.custom.value
            ? "tw-flex-col md:tw-flex-row tw-gap-3 md:tw-gap-0 md:tw-items-center"
            : "tw-flex-row-reverse md:tw-flex-row tw-justify-between md:tw-justify-normal tw-items-center"
        )}
      >
        <Dropdown
          options={Object.values(date_range_select_options)}
          value={selectedRange}
          handleChange={onRangeChange}
          placeholder="Select date range"
          className={`mr-md-4 !tw-h-[40px] !tw-w-[153px] tw-border-[1.5px] tw-border-solid tw-border-[#cfcdc9] tw-rounded-[5px]`}
        />
        {selectedRange !== date_range_select_options.custom.value ? (
          <p className="!tw-m-0 tw-text-[16px] tw-font-medium tw-tracking-[0.64px] tw-flex tw-items-center">
            {dataRange}
          </p>
        ) : (
          <div className="tw-flex tw-w-full md:tw-w-auto tw-items-center">
            <DatePicker
              size={!isDesktop ? "thin" : "small"}
              popperClassName="!tw-z-[11]"
              placeholder="From date"
              value={
                startDate
                  ? convertStringToDateObject({ dateString: startDate })
                  : null
              }
              onChange={(date) =>
                setStartDate(format(date, YEAR_MONTH_DAY_FORMAT))
              }
              wrapperClassName="tw-w-1/2 md:tw-w-[140px] tw-mr-2 !tw-h-[40px] tw-bg-white"
            />
            <DatePicker
              popperPlacement={isDesktop ? "bottom-end" : ""}
              size={!isDesktop ? "thin" : "small"}
              wrapperClassName={classnames(
                "tw-w-1/2 md:tw-w-[140px] md:tw-ml-2 !tw-h-[40px] tw-bg-white",
                {
                  "!tw-pointer-events-none": !startDate,
                }
              )}
              popperClassName="!tw-z-[11]"
              minDate={
                startDate
                  ? convertStringToDateObject({ dateString: startDate })
                  : null
              }
              disabled={!startDate}
              placeholder="To date"
              value={
                endDate
                  ? convertStringToDateObject({ dateString: endDate })
                  : null
              }
              onChange={(date) =>
                setEndDate(format(date, YEAR_MONTH_DAY_FORMAT))
              }
            />
          </div>
        )}
      </div>
      <div className="tw-flex tw-w-[calc(100vw-32px)] tw-overflow-x-scroll tw-gap-[15px] tw-mb-[26px] md:tw-w-full md:tw-gap-[26px] md:tw-mb-[20px] md:tw-overflow-x-visible">
        <StatsCard
          className="tw-mb-4 md:tw-mb-0"
          color="primary"
          linkText=""
          title={STAT_CARDS.BOOKINGS.title}
          tooltip="Number of bookings received via all tracking links"
          statsNumber={
            discountStatsData ? (
              discountStatsData?.total_bookings
            ) : (
              <StatsLoadingState color="primary" />
            )
          }
          Icon={() => (
            <ExlyImage
              src={getS3AssetCDNUrl("assets/vectors/dashboard/booking.png")}
              width={28}
              height={28}
              className="!tw-mr-[16px]"
            />
          )}
        />
        <StatsCard
          className="tw-mb-4 md:tw-mb-0"
          color="fine_pine"
          linkText=""
          title={STAT_CARDS.REVENUE.title}
          tooltip="Total revenue received via all tracking links"
          statsNumber={
            discountStatsData ? (
              formatRevenue(discountStatsData?.total_revenue)
            ) : (
              <StatsLoadingState color="fine_pine" />
            )
          }
          Icon={() => (
            <ExlyImage
              src={getS3AssetCDNUrl("assets/vectors/dashboard/revenue.png")}
              width={28}
              height={28}
              className="!tw-mr-[16px]"
            />
          )}
        />
      </div>
    </Box>
  );
};
